import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, InputGroup, Label, Row } from 'reactstrap'
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom';
import useApi from 'common/ApiMiddlewere';
import { dateFormat, dateTimeFormatIOS, formatDateToISO } from 'pages/Common';
import { routes } from 'routes/path';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const MakingCreate = ({ data, isEdit }) => {
    const flatpickrRef = useRef(null);
    const navigate = useNavigate()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [isLoading, setIsLoading] = useState(false)
    // const [isEdit, setIsEdit] = useState(isEdit)
    const [makingId, setMakingId] = useState(data?.Id)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [occasionDate, setOccasionDate] = useState(dateFormat(isEdit ? new Date(data?.OccasionDate) : new Date(), "dd-MM-yyyy"))
    const [inquiryDate, setInquiryDate] = useState(dateFormat(isEdit ? new Date(data?.InquiryDate) : new Date(), "dd-MM-yyyy"))
    const [userFilter, setUserFilter] = useState(
        {
            label: isEdit ? data?.AttendByName : 'Select user',
            value: isEdit ? data?.AttendBy : 0,
        }
    )
    const [userControls, setUserControls] = useState([])
    const [categoryId, setCategoryId] = useState(isEdit ? data?.CategoryId : 0)
    const [categories, setCategories] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [isCategoryError, setIsCategoryError] = useState(false)
    const [isUserError, setIsUserError] = useState(false)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                options.unshift({
                    label: "Select user",
                    value: 0,
                }
                );
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi("Common/category/lookup").then(({ data, status }) => {
            if (status === 200) {
                setCategories(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

    }, [])

    const handleCancel = () => {
        navigate(routes.rentmakinglist, {
            state: {
                tab: "2",
            },
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Name: isEdit ? data?.Name : "",
            ContactNo: isEdit ? data?.ContactNo : "",
            City: isEdit ? data?.City : "",
        },
        validationSchema: Yup.object({
            // Date: Yup.string().required("The date is required"),
            Name: Yup.string().required("The name is required"),
            ContactNo: Yup.string().required("The contact no is required"),
            City: Yup.string().required("The city is required"),
        }),
        onSubmit: values => {
            if (parseInt(categoryId) == 0) {
                setIsCategoryError(true)
                setErrorMessage("The category is required")
                return true
            } else if (parseInt(userFilter?.value) == 0) {
                setIsUserError(true)
                setErrorMessage("The attend by is required")
                return true
            }
            setformSumitLoading(true)
            if (values) {

                isEdit
                    ?
                    putApi("unbill/making/update", {
                        Id: makingId,
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        inquiryDate: formatDateToISO(inquiryDate),
                        CategoryId: parseInt(categoryId),
                        OccasionDate: formatDateToISO(occasionDate),
                        AttendBy: parseInt(userFilter.value),
                        City: values.City,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            handleCancel()
                            toast.success("successfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            // toggle()
                            // categoryApi()
                            validation.handleReset()
                        }
                    })
                    :
                    postApi("unbill/making/create", {
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        inquiryDate: formatDateToISO(inquiryDate),
                        CategoryId: parseInt(categoryId),
                        OccasionDate: formatDateToISO(occasionDate),
                        AttendBy: parseInt(userFilter.value),
                        City: values.City,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            handleCancel()
                            toast.success("successfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            // toggle()
                            // categoryApi()
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    return (
        <>
            <Form
                onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                }}
                onReset={e => {
                    e.preventDefault
                    validation.handleReset()
                    return false
                }}
            >
                <Row>
                    <Col md={7} className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="validationCustom03"
                                className="required"
                            >
                                Name
                            </Label>
                            <InputGroup style={{ paddingRight: "0px" }}>
                                <Input
                                    name="Name"
                                    placeholder=" Name"
                                    type="text"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.Name || ""}
                                    invalid={
                                        validation.touched.Name && validation.errors.Name
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.Name && validation.errors.Name ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.Name}
                                    </FormFeedback>
                                ) : null}
                            </InputGroup>
                        </div>
                    </Col>
                    <Col md="2" className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="validationCustom03"
                                className="required"
                            >
                                Contact No
                            </Label>
                            <Input
                                name="ContactNo"
                                placeholder="Contact No."
                                type="text"
                                maxLength="10"
                                className="form-control-sm"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.ContactNo || ""}
                                onKeyPress={handleKeyPress}
                                invalid={
                                    validation.touched.ContactNo &&
                                        validation.errors.ContactNo
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.ContactNo &&
                                validation.errors.ContactNo ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.ContactNo}
                                </FormFeedback>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={3} className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="productDetailsValidationCustom01"
                                className=""
                            >
                                Inquiry Date
                            </Label>
                            <div className="d-flex date-after" >
                                <Flatpickr
                                    ref={flatpickrRef}
                                    className="form-control d-block flatpicker-date"
                                    placeholder="dd-MM-yyyy"
                                    value={inquiryDate}
                                    onChange={(e) => setInquiryDate(e)}
                                    options={{
                                        dateFormat: "d-m-Y",
                                        disableMobile: true
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md="2" className="table-header">
                        <Label
                            htmlFor="validationCustom03"
                            className="required"
                        >
                            Category
                        </Label>
                        <Input
                            disabled={isEdit}
                            type="select"
                            id="validationCustom01"
                            bsSize='sm'
                            className="form-control-sm"
                            name="category"
                            onChange={e => {
                                setCategoryId(e.target.value)
                                setIsCategoryError(false)
                            }}
                            value={categoryId}
                        >
                            <option value={0}>category</option>
                            {categories.map((item, index) => {
                                return (
                                    <option key={index} value={item.Key}>{item.Value}</option>
                                )
                            })}
                        </Input>
                        {isCategoryError ? (
                            <div className="name-required">
                                {errorMessage}
                            </div>
                        ) : null}
                    </Col>
                    <Col md={2} className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="productDetailsValidationCustom01"
                                className=""
                            >
                                Occasion Date
                            </Label>
                            <div className="d-flex date-after" >
                                <Flatpickr
                                    ref={flatpickrRef}
                                    className="form-control d-block flatpicker-date"
                                    placeholder="dd-MM-yyyy"
                                    value={occasionDate}
                                    onChange={(e) => setOccasionDate(e)}
                                    options={{
                                        dateFormat: "d-m-Y",
                                        disableMobile: true
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md="2" className="">
                        <div className="mb-2">
                            <Label
                                htmlFor="validationCustom03"
                                className="required"
                            >
                                City
                            </Label>
                            <Input
                                name="City"
                                placeholder="City"
                                type="text"
                                className="form-control-sm"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.City || ""}
                                invalid={
                                    validation.touched.City &&
                                        validation.errors.City
                                        ? true
                                        : false
                                }
                            />
                            {validation.touched.City &&
                                validation.errors.City ? (
                                <FormFeedback type="invalid">
                                    {validation.errors.City}
                                </FormFeedback>
                            ) : null}
                        </div>
                    </Col>
                    <Col md={3}>
                        <FormGroup className="mb-2">
                            <Label
                                htmlFor="example-time-input"
                                className="col-form-Label required"
                            >
                                Attend By
                            </Label>
                            <Select
                                unstyled
                                styles={colourStyles}
                                value={userFilter}
                                onChange={(e) => {
                                    setUserFilter(e)
                                    setIsUserError(false)
                                }}
                                options={userControls}
                                className="select2-selection"
                            />
                            {isUserError ? (
                                <div className="name-required">
                                    {errorMessage}
                                </div>
                            ) : null}
                        </FormGroup>
                    </Col>
                </Row>
                <div className="text-end mt-3">
                    <Button
                        task-title="secondary"
                        className="btn btn-primary me-2 btn-sm "
                        type="button"
                        color="secondary"
                        onClick={() => handleCancel()}
                    >
                        Cancel
                    </Button>
                    {formSumitLoading ? (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                        >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                        </button>
                    ) : (
                        <Button
                            color="primary"
                            task-title="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                        >
                            Submit
                        </Button>
                    )}
                </div>
            </Form>
        </>
    )
}

export default MakingCreate